import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import { Col, Offcanvas } from "react-bootstrap";
import moment from "moment";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";

import ILogMantenedor from "../../../../entities/ILogMantenedor";
import ISubContratista from "../../../../entities/ISubContratista";

import IVicePresidencia from "../../../../entities/IVicePresidencia";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import {
  API_ADMIN_MANTENEDOR_PLANIFICACION,
  API_ADMIN_ESTADO_PLANIFICACION,
  API_ADMIN_PRODUCTO,
  API_ADMIN_TIPO_PROCESO,
  API_ADMIN_PROVEEDOR,
  ROW_COUNT,
  URL_SUPPORT,
  API_ADMIN_AREA_RESPONSABLE,
} from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import IPlanificacion from "../../../../entities/IPlanificacion";
import { ITipoProceso } from "../../../../entities/ITipoProceso";
import { IProducto } from "../../../../entities/IProducto";
import { IEstadoPlanificacion } from "../../../../entities/IEstadoPlanificacion";
import { IProveedor } from "../../../../entities/IProveedor";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";

import CustomToast from "../../../../cross/CustomToast";
import { cParamsActiveOrderTitle } from "../../../../helpers/paramsHelper";
import { updateFilter, updateSelectedField } from "../UtilsMantenedor";
import { downloadFile } from "../../../../helpers/fileHelper";
import ProveedorService from "../../../../services/ProveedorService";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";
const MySwal = withReactContent(Swal);

interface IMantenedorPlanificacionesProps {
  items?: Array<any>;
  cbVicePresidencia?: Array<IVicePresidencia>;
  cbTipoProceso?: Array<ITipoProceso>;
  cbSubContratista?: Array<ISubContratista>;
  cbProducto?: Array<IProducto>;
  cbProveedor?: Array<IProveedor>;
  cbEstadoPlanificacion?: Array<IEstadoPlanificacion>;
  itemsArrCambiosForm?: Array<IConfirmacionMantenedor>;
  is_test?: boolean;
  loading?: boolean;
  editColumnInfo?: any;
}

export default function MantenedorPlanificaciones({
  editColumnInfo,
  loading,
  is_test,
  cbSubContratista,
  items,
  cbVicePresidencia,
  cbTipoProceso,
  cbProducto,
  cbProveedor,
  cbEstadoPlanificacion,
  itemsArrCambiosForm,
}: IMantenedorPlanificacionesProps) {
  let paramsActive = cParamsActiveOrderTitle;
  const userInfo = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [comboVccMPL, setComboVccMPL] = useState<Array<IVicePresidencia>>(cbVicePresidencia || []);
  const [comboEPMPL, setcomboEPMPL] = useState<Array<IEstadoPlanificacion>>(cbEstadoPlanificacion || []);
  const [comboTPMPL, setComboTPMPL] = useState<Array<ITipoProceso>>(cbTipoProceso || []);
  const [comboPRDMPL, setComboPRDMPL] = useState<Array<IProducto>>(cbProducto || []);
  const [comboPRVMPL, setComboPRVMPL] = useState<Array<IProveedor>>(cbProveedor || []);

  const [isEditColumMPL, setIsEditColumMPL] = useState<boolean>(is_test ?? false);
  const [editColumnInfoMPL, setEditColumnInfoMPL] = useState<any>(editColumnInfo);

  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [isLoading, setIsLoading] = useState(loading ?? false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);

  const [showToast, setShowToast] = useState(false);
  const [hideTable, setHideTable] = useState(true);

  const [arrCambiosForm, setArrCambiosForm] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambiosForm || []);
  const [isOpenPopUpGuardarCambios, setIsOpenPopUpGuardarCambios] = useState<boolean>(is_test ?? false);

  const refTxtCorr = React.createRef<HTMLInputElement>();
  const [refComboUPMPL, setValComboUPMPL] = useState<IComboboxOption | null>(null);
  const [refComboARMPL, setValComboARMPL] = useState<IComboboxOption | null>(null);
  const [refComboGSGMPL, setValComboGSGMPL] = useState<IComboboxOption | null>(null);
  const [refComboCSCMPL, setValComboCSCMPL] = useState<IComboboxOption | null>(null);
  const [refcomboEPMPL, setValComboEPMPL] = useState<IComboboxOption | null>(null);
  const [selectedField, setSelectedField] = useState({} as any);
  const refTxtMotivo = React.createRef<HTMLTextAreaElement>();
  const [refComboTPMPL, setValComboTPMPL] = useState<IComboboxOption | null>(null);
  const [refComboPRDMPL, setValComboPRDMPL] = useState<IComboboxOption | null>(null);
  const [refcomboPRVMPL, setValComboPRVMPL] = useState<IComboboxOption | null>(null);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [msjErrorForm, setMsjErrorForm] = useState<string[]>([]);
  const [isSendingData, setIsSendingData] = useState(false);
  const columnHelperMantPlanificacion = createColumnHelper<IPlanificacion>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();

  const changeField = (id: string, valor: any) => {
    let sf: any = updateSelectedField(id, valor);
    setSelectedField(sf);
  };
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };
  const componentValue = (value: any, type?: number) => {
    return <RenderValue value={value} type={type} />;
  };
  const componentLink = (value: any) => {
    return <RenderLink value={value} />;
  };

  const componentDesactivar = (value: any) => {
    let desactivar = value.row.original.ACTIVO ? "Desactivar" : "Activar";
    return (
      <button
        className="btnIcono"
        title={desactivar}
        onClick={() => {
          MySwal.fire({
            html: (
              <div>
                <h3>
                  ¿Desea {desactivar.toLowerCase()} el registro {value.row.original.TITULO}?
                </h3>
              </div>
            ),
            text: "",
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              MySwal.fire({
                html: (
                  <div>
                    <h4>Ingrese un Motivo:</h4>
                  </div>
                ),
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: `<i class="bi bi-eye"></i>${desactivar}`,
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async (txtMotivo) => {
                  preconfirm(txtMotivo, value.row.original.ID_PLAN as number, value.row.original.ACTIVO, value.row.original.TITULO);
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                console.log("");
              });
            }
          });
        }}>
        <i className={value.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
      </button>
    );
  };

  const preconfirm = async (txtMotivo: string, id_registro: number, activo: boolean, titulo: string) => {
    if (!txtMotivo) {
      Swal.showValidationMessage(`Debe ingresar un motivo`);
    } else {
      await ProveedorService.desactivarRegistroPlanificacion(token, {
        ID_REGISTRO: id_registro,
        AUTOR: currentUser?.email as string,
        AUTOR_DISPLAY: currentUser?.fullname as string,
        CAMPO: "N/A",
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        MODULO: "PROVEEDORES",
        TABLA: "PLANIFICACION",
        MOTIVO: txtMotivo,
        VALOR_INICIAL: "N/A",
        DESACTIVAR: activo,
        FECHA_CREACION: new Date(),
        FECHA_MODIFICACION: new Date(),
        VALOR_FINAL: "N/A",
        ACCION: activo ? "DESACTIVAR" : "ACTIVAR",
        CORRELATIVO: titulo,
      });
      await handleBuscarMPL();
    }
  };
  let columnsDef = [
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.TITULO, {
      id: "TITULO",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Título"),
      hide: false,
      title: "Título",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `PF."TITULO"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.ID, {
      id: "DESACTIVAR",
      cell: (info: CellContext<IPlanificacion, number>) => componentDesactivar(info),
      header: () => componentValue("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IPlanificacion, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.ANIO, {
      id: "ANIO",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Año"),
      hide: false,
      title: "Año",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `PL."ANIO"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.AREA_RESPONSABLE, {
      id: "AREA_RESPONSABLE_COLUMNA",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Área Responsable"),
      hide: false,
      title: "Área Responsable",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"AREA_RESPONSABLE"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.TIPO_PROCESO, {
      id: "TIPO_PROCESO_COLUMNA",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Proceso"),
      hide: false,
      title: "Tipo Proceso",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"TIPO_PROCESO"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.PRODUCTO, {
      id: "PRODUCTO_COLUMNA",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Producto"),
      hide: false,
      title: "Producto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"PRODUCTO"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.NOMBRE_PROVEEDOR, {
      id: "TIPO_PROVEEDOR",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(info.getValue()),
      header: () => component("Proveedor"),
      hide: false,
      title: "Proveedor",
      tipo: ITipo_Campo.user,
      className: "colorGris",
      sortId: `"TIPO_PROVEEDOR"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (info: CellContext<IPlanificacion, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Creación"),
      hide: false,
      title: "Fecha Creación",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `PF."FECHA_CREACION"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.PROVEEDOR_RESPONSABLE_DISPLAY, {
      id: "PROVEEDOR_RESPONSABLE",
      cell: (info: CellContext<IPlanificacion, string>) => componentLink(info.getValue()),
      header: () => component("Nombre Proveedor"),
      hide: false,
      title: "Nombre Proveedor",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMPL(cell);
        setIsEditColumMPL(true);
        setIsSendingData(false);
      },
      sortId: `"PROVEEDOR_RESPONSABLE"`,
    } as any),
    columnHelperMantPlanificacion.accessor((row) => shortDate(row.FECHA_EVALUACION), {
      id: "FECHA_EVALUACION",
      cell: (info: CellContext<IPlanificacion, string>) => componentLink(info.getValue()),
      header: () => component("Fecha Evaluación"),
      hide: false,
      title: "Fecha Evaluación",
      tipo: ITipo_Campo.date,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMPL(cell);
        setIsEditColumMPL(true);
        setIsSendingData(false);
      },
      sortId: `PF."FECHA_EVALUACION"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.EVALUADOR_LIDER_DISPLAY || rowMPL.EVALUADOR_LIDER, {
      id: "EVALUADOR_LIDER",
      cell: (info: CellContext<IPlanificacion, string>) => componentLink(info.getValue()),
      header: () => component("Evaluador Líder"),
      hide: false,
      title: "Evaluador Líder",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMPL(cell);
        setIsEditColumMPL(true);
        setIsSendingData(false);
      },
      sortId: `PF."EVALUADOR_LIDER_DISPLAY"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.EVALUADOR_LIDER_DISPLAY, {
      id: "EVALUADOR_LIDER_DISPLAY",
      cell: (info: CellContext<IPlanificacion, string>) => componentLink(info.getValue()),
      header: () => component("Evaluador Líder"),
      hide: true,
      title: "Evaluador Líder",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMPL(cell);
        setIsEditColumMPL(true);
        setIsSendingData(false);
      },
      sortId: `PF."EVALUADOR_LIDER_DISPLAY"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.EVALUADORES_DISPLAY || rowMPL.EVALUADORES, {
      id: "EVALUADORES",
      cell: (info: CellContext<IPlanificacion, string>) => componentLink(info.getValue()),
      header: () => component("Evaluadores"),
      hide: false,
      title: "Evaluadores",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMPL(cell);
        setIsEditColumMPL(true);
        setIsSendingData(false);
      },
      sortId: `PF."EVALUADORES"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.EVALUADORES_DISPLAY, {
      id: "EVALUADORES_DISPLAY",
      cell: (info: CellContext<IPlanificacion, string>) => componentLink(info.getValue()),
      header: () => component("Evaluadores"),
      hide: true,
      title: "Evaluadores",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMPL(cell);
        setIsEditColumMPL(true);
        setIsSendingData(false);
      },
      sortId: `PF."EVALUADORES_DISPLAY"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.AUTOR_DISPLAY || rowMPL.AUTOR, {
      id: "AUTOR",
      cell: (info: CellContext<IPlanificacion, string>) => componentLink(info.getValue()),
      header: () => component("Creado por"),
      hide: false,
      title: "Creado por",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMPL(cell);
        setIsEditColumMPL(true);
        setIsSendingData(false);
      },
      sortId: `"AUTOR"`,
    } as any),
    columnHelperMantPlanificacion.accessor((rowMPL) => rowMPL.AUTOR_DISPLAY, {
      id: "AUTOR_DISPLAY",
      cell: (info: CellContext<IPlanificacion, string>) => componentLink(info.getValue()),
      header: () => component("Creado por"),
      hide: true,
      title: "Creado por",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMPL(cell);
        setIsEditColumMPL(true);
        setIsSendingData(false);
      },
      sortId: `"AUTOR_DISPLAY"`,
    } as any),
  ] as any;

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const comboVccMPL = is_test
      ? cbVicePresidencia
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_AREA_RESPONSABLE}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setComboVccMPL(comboVccMPL);
    const comboEPMPL = is_test
      ? cbEstadoPlanificacion
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_ESTADO_PLANIFICACION}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
    setcomboEPMPL(comboEPMPL);
  }, []);

  const getAllTipoProceso = async (e: any) => {
    let newParamsActive = { ...paramsActive, AREA_RESPONSABLE: e.value };
    const comboTPMPL = is_test
      ? cbTipoProceso
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_TIPO_PROCESO}/getall`, { Authorization: `Bearer ${token}` }, newParamsActive)).result.data;
    setComboTPMPL(comboTPMPL);
  };

  const getAllProductos = async (e: any) => {
    let newParamsActive = { ...paramsActive, TIPO_PROCESO: e.value };
    const comboPRDMPL = is_test
      ? cbProducto
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_PRODUCTO}/getall`, { Authorization: `Bearer ${token}` }, newParamsActive)).result.data;
    setComboPRDMPL(comboPRDMPL);
  };
  const getAllProveedores = async (e: any) => {
    let newParamsActive = { ...paramsActive, PRODUCTO: e.value };
    const comboPRVMPL = is_test
      ? cbProveedor
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/getall`, { Authorization: `Bearer ${token}` }, newParamsActive)).result.data;
    setComboPRVMPL(comboPRVMPL);
  };

  const exportFileMPL = () => {
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      ANIO: refTxtCorr.current?.value,
      AREA_RESPONSABLE: refComboARMPL?.value,
      TIPO_PROCESO: refComboTPMPL?.value,
      PRODUCTO: refComboPRDMPL?.value,
      NOMBRE_PROVEEDOR: refcomboPRVMPL?.value,
      ESTADO_PLANIFICACION: refcomboEPMPL?.value,
    };
    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_PLANIFICACION}/ExportMantenedorPlanificacion`, { Authorization: `Bearer ${token}` }, params).then(
      (r) => {
        downloadFile(r.result);
      }
    );
  };

  const paging = (page: any) => {
    setPage(page);
    filterMPL({ PAGINA: page }, true);
  };

  const filterMPL = (filterMPL: any, page: boolean = false, size = pageSize) => {
    filterMPL = updateFilter(filterMPL, size, page);
    setPage(filterMPL.PAGINA);

    const valCorr = refTxtCorr.current?.value;
    const valAreaResp = refComboARMPL?.value;
    const valUP = refComboUPMPL?.value;
    const valGSG = refComboGSGMPL?.value === "Seleccione" ? "" : refComboGSGMPL?.value;
    const valCSC = refComboCSCMPL?.value === "Seleccione" ? "" : refComboCSCMPL?.value;
    const valEP = refcomboEPMPL?.value === "Seleccione" ? "" : refcomboEPMPL?.value;
    const valPRD = refComboPRDMPL?.value === "Seleccione" ? "" : refComboPRDMPL?.value;
    const valPRV = refcomboPRVMPL?.value;
    const valTP = refComboTPMPL?.value === "Seleccione" ? "" : refComboTPMPL?.value;

    filterMPL.UNIDAD_PROYECTO = valUP;
    filterMPL.GERENCIA_SUBGERENCIA = valGSG;
    filterMPL.VICEPRESIDENCIA = valAreaResp;
    filterMPL.CONTRATISTA_SUBCONTRATISTA = valCSC;
    filterMPL.ESTADO = valEP;
    filterMPL.CORRELATIVO = valCorr;
    filterMPL.TIPO_PROCESO = valTP;
    filterMPL.PRODUCTO = valPRD;
    filterMPL.PROVEEDOR = valPRV;

    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_PLANIFICACION}`, { Authorization: `Bearer ${token}` }, filterMPL)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  const editMPL = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  const validateNotSameUsers = (columnId: string, originalRow: any): boolean => {
    let txtError = [];
    let isInvalid = false;
    let flag = true;
    if (columnId === "FECHA_EVALUACION" && moment(selectedField.FECHA_EVALUACION).year() !== originalRow.ANIO) {
      isInvalid = true;
      txtError.push("La fecha debe estar dentro del año de la planificación");
    }
    if (
      columnId === "PROVEEDOR_RESPONSABLE" &&
      (originalRow.EVALUADOR_LIDER === selectedField.PROVEEDOR_RESPONSABLE ||
        isEvaluators(originalRow.EVALUADORES, selectedField.PROVEEDOR_RESPONSABLE))
    ) {
      isInvalid = true;
      txtError.push("Evaluadores o Evaluador Líder, no pueden ser el Proveedor Responsable");
    }
    if (
      columnId === "EVALUADOR_LIDER" &&
      (originalRow.PROVEEDOR_RESPONSABLE === selectedField.EVALUADOR_LIDER || isEvaluators(originalRow.EVALUADORES, selectedField.EVALUADOR_LIDER))
    ) {
      isInvalid = true;
      txtError.push("Evaluadores o Proveedor, no pueden ser Evaluador Líder");
    }
    if (
      columnId === "EVALUADORES" &&
      (isEvaluators(selectedField.EVALUADORES, originalRow.PROVEEDOR_RESPONSABLE) ||
        isEvaluators(selectedField.EVALUADORES, originalRow.EVALUADOR_LIDER))
    ) {
      isInvalid = true;
      txtError.push("Evaluador Lider o Proveedor, no pueden ser Evaluadores adicionales");
    }

    if (isInvalid) {
      flag = false;
      setMsjErrorForm(txtError);
    }

    return flag;
  };

  const isEvaluators = (users: string | undefined, emailUser: string) => {
    if (users !== undefined && users !== null) {
      let arrayUsers = users.split("; ");
      const result = arrayUsers.some((user) => user.trim() === emailUser);
      return result;
    }
    return false;
  };

  const confirm = () => {
    let arrDesviaciones: Array<IPlanificacion> = [];
    let arrLogs: Array<ILogMantenedor> = [];

    let cambios = is_test ? itemsArrCambiosForm ?? [] : arrCambiosForm;
    cambios.forEach((ac) => {
      if (!arrDesviaciones.find((d) => d.ID === ac.ID)) {
        arrDesviaciones.push(ac.OBJETO_REF);
      }
    });

    arrDesviaciones.forEach((d: any) => {
      cambios
        .filter((ac) => ac.ID === d.ID)
        .forEach((ac) => {
          ac.CAMPO_EDITADO_ID = ac.CAMPO_EDITADO_ID.replace("_COLUMNA", "");
          let log: ILogMantenedor = {
            ID: null,
            MODULO: "PROVEEDORES",
            TABLA: "PLANIFICACION",
            ID_REGISTRO: d.ID,
            CAMPO: ac.CAMPO_EDITADO_ID,
            VALOR_INICIAL: ac.VALOR_ORIGINAL,
            VALOR_FINAL: null,
            MOTIVO: refTxtMotivo.current?.value || "",
            AUTOR: currentUser?.email || "",
            FECHA_CREACION: new Date(),
            EDITOR: "",
            FECHA_MODIFICACION: new Date(),
            AUTOR_DISPLAY: currentUser?.fullname || "",
            EDITOR_DISPLAY: "",
            CORRELATIVO: d.CORRELATIVO,
          };

          if (ac.TIPO === ITipo_Campo.user) {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
            d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
            log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
          } else {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          }
          arrLogs.push(log);
        });
    });

    let value = {
      LOG_MANTENEDOR: arrLogs,
      PLANIFICACION: arrDesviaciones,
    };

    postAPI(`${URL_SUPPORT}${API_ADMIN_PROVEEDOR}/MantenedorPlanificacion`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        let params = { PAGINA: page };
        filterMPL(params);
        if (refTxtMotivo.current) {
          refTxtMotivo.current.value = "";
        }
        setArrCambiosForm([]);
        setIsOpenPopUpGuardarCambios(false);
        setShowToast(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleBuscarMPL = async () => {
    setIsLoading(true);
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      ANIO: refTxtCorr.current?.value,
      AREA_RESPONSABLE: refComboARMPL?.value == "Seleccione" ? "" : refComboARMPL?.value,
      TIPO_PROCESO: refComboTPMPL?.value == "Seleccione" ? "" : refComboTPMPL?.value,
      PRODUCTO: refComboPRDMPL?.value == "Seleccione" ? "" : refComboPRDMPL?.value,
      NOMBRE_PROVEEDOR: refcomboPRVMPL?.value == "Seleccione" ? "" : refcomboPRVMPL?.value,
      ESTADO_PLANIFICACION: refcomboEPMPL?.value == "Seleccione" ? "" : refcomboEPMPL?.value,
    };
    const result = is_test
      ? { data: [], pages: 10 }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_PLANIFICACION}`, { Authorization: `Bearer ${token}` }, params)).result;
    let list = result.data;
    setListItems(list);
    let pages = result.pages;
    setPages(pages);

    setHideTable(false);
    setIsLoading(false);
  };

  const render = () => {
    if (editColumnInfoMPL?.column?.id === "NOMBRE_PROVEEDOR") {
      if (editColumnInfoMPL.row.original.TIPO_PROVEEDOR === "Externo") {
        return ITipo_Campo.userexternal;
      } else {
        return ITipo_Campo.userinternal;
      }
    } else {
      return editColumnInfoMPL?.column.columnDef.tipo;
    }
  };

  return (
    <section>
      <div className="row">
        <button
          data-testid="btnedit"
          hidden={true}
          onClick={() => {
            handleBuscarMPL();
            exportFileMPL();
            filterMPL({});
            editMPL({ ID: "" }, {});
            paging(1);
            preconfirm("", 1, true, "");
            preconfirm("2", 1, true, "");
            confirm();
            getAllTipoProceso("");
            getAllProductos("");
            getAllProveedores("");
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Proveedores - Planificaciones</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="row mb-1 ajusteInput">
                <div className="col-6">
                  <Col>
                    <label>Año:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtCorr} className="form-control form-control-sm" />
                  </Col>
                </div>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Área Responsable:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboARMPL || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboVccMPL.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboARMPL(e);
                      getAllTipoProceso(e);
                      setValComboTPMPL(null);
                      setValComboPRDMPL(null);
                      setValComboPRVMPL(null);
                      setComboPRDMPL([]);
                      setComboPRVMPL([]);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Tipo Proceso:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboTPMPL || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboTPMPL.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboTPMPL(e);
                      getAllProductos(e);
                      setValComboPRDMPL(null);
                      setValComboPRVMPL(null);
                      setComboPRVMPL([]);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Producto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboPRDMPL || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboPRDMPL.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboPRDMPL(e);
                      getAllProveedores(e);
                      setValComboPRVMPL(null);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Proveedor:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refcomboPRVMPL || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboPRVMPL.map((vcc) => ({ value: vcc.PROVEEDOR, label: vcc.PROVEEDOR }))}
                    onChange={async (e: any) => {
                      setValComboPRVMPL(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Estado Planificación:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refcomboEPMPL || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboEPMPL.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboEPMPL(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6"></Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      handleBuscarMPL();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      (refTxtCorr.current as HTMLInputElement).value = "";
                      setValComboARMPL(null);
                      setValComboUPMPL(null);
                      setValComboGSGMPL(null);
                      setValComboCSCMPL(null);
                      setValComboEPMPL(null);
                      setValComboTPMPL(null);
                      setValComboPRDMPL(null);
                      setValComboPRVMPL(null);
                      setListItems([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>

                  {arrCambiosForm.length > 0 && (
                    <button
                      className="btn btn-secondary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambios(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        <AdminLista
          reload={filterMPL}
          items={[]}
          callback={editMPL}
          data={listItems}
          tipo={"MantenedorPlanificaciones"}
          filter={filterMPL}
          pagination={{ pages: pages, page: page, paging: paging }}
          title=""
          hideAdd={true}
          hideExport={true}
          exportar={exportFileMPL}
          columnsDef={columnsDef}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filterMPL(filters, false, pageSize);
          }}
          isLoading={isLoading}
        />
      </div>

      {editColumnInfoMPL && (
        <Offcanvas
          show={isEditColumMPL}
          onHide={() => {
            setMsjErrorForm([]);
            setIsEditColumMPL(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfoMPL.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              <div>
                {editColumnInfoMPL &&
                  (editColumnInfoMPL.getValue()?.TIPO === ITipo_Campo.date ? shortDate(editColumnInfoMPL.getValue()) : editColumnInfoMPL.getValue())}
              </div>
            </div>
            <div className="row mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
                <form className="form-control-sm">
                  {
                    <RenderForm
                      id={editColumnInfoMPL?.column?.id.replace("_COLUMNA", "")}
                      tipoCampo={render()}
                      valor={""}
                      texto={""}
                      callback={changeField}
                    />
                  }
                </form>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  data-testid="btnaceptar"
                  onClick={() => {
                    let arr = arrCambiosForm;
                    let campoEditadoId = editColumnInfoMPL.column.columnDef.id;
                    campoEditadoId = campoEditadoId.replace("_COLUMNA", "");

                    let json = {
                      ID: editColumnInfoMPL.row.original.ID_PLAN,
                      CAMPO_EDITADO: editColumnInfoMPL.column.columnDef.title,
                      CAMPO_EDITADO_ID: campoEditadoId,
                      VALOR_ORIGINAL: editColumnInfoMPL?.getValue(),
                      VALOR_NUEVO:
                        editColumnInfoMPL.column.columnDef.tipo === ITipo_Campo.user
                          ? selectedField
                          : selectedField[editColumnInfoMPL.column.columnDef.id],
                      OBJETO_REF: {
                        ...editColumnInfoMPL.row.original,
                        ID: editColumnInfoMPL.row.original.ID_PLAN,
                      },
                      TIPO: editColumnInfoMPL.column.columnDef.tipo,
                    };
                    const columnId = campoEditadoId;
                    const originalRow: IPlanificacion = editColumnInfoMPL.row.original;
                    let notSameUserTable = false;
                    let notSameUserForm = false;
                    let isSameUserForm = false;
                    arrCambiosForm.forEach((cambioForm) => {
                      if (cambioForm.ID === json.ID && !isSameUserForm) {
                        let NotSameUser = validateNotSameUsers(json.CAMPO_EDITADO_ID, cambioForm.VALOR_NUEVO);
                        if (!NotSameUser) isSameUserForm = true;
                      }
                    });
                    if (!isSameUserForm) notSameUserForm = true;

                    notSameUserTable = validateNotSameUsers(columnId, originalRow);

                    if (notSameUserTable && notSameUserForm && !isSendingData) {
                      arr.push(json);
                      setArrCambiosForm(arr);
                      setIsEditColumMPL(false);
                      setIsSendingData(true);
                      setMsjErrorForm([]);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColumMPL(false);
                    setMsjErrorForm([]);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
              {msjErrorForm.length > 0 && <span className="error mt-2">{msjErrorForm.concat("\n")}</span>}
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambios && (
        <Offcanvas
          show={isOpenPopUpGuardarCambios}
          onHide={() => {
            setIsOpenPopUpGuardarCambios(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Desviaciones:</span>
            </div>
            <div className="row mb-2">
              <AdminLista
                reload={filterMPL}
                items={[]}
                callback={editMPL}
                data={arrCambiosForm}
                tipo={"MantenedorDesviaciones"}
                filter={filterMPL}
                pagination={{ pages: pages, page: page, paging: paging }}
                title=""
                hideAdd={true}
                hideExport={true}
                hideReload={true}
                hidePagination={true}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((rowMPL) => rowMPL.ID, {
                    id: "ID",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMPL) => rowMPL.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMPL) => rowMPL.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (info: CellContext<IConfirmacionMantenedor, any>) => componentValue(info.getValue(), info.getValue()?.TIPO),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMPL) => rowMPL.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (info: CellContext<IConfirmacionMantenedor, any>) =>
                      componentValue(
                        info.getValue(),
                        moment(info.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : info.getValue()?.TIPO
                      ),
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="row mb-2">
              <div className="row mb-2">
                <div className="col-12">
                  <label>Motivos Modificación</label>
                </div>
                <div className="col-12">
                  <textarea ref={refTxtMotivo} className="w-100"></textarea>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    if (!refTxtMotivo.current?.value) {
                      refTxtMotivo.current?.classList.add("error");
                      return;
                    } else {
                      refTxtMotivo.current?.classList.remove("error");
                    }
                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivo.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        confirm();
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambios(false);
                  }}>
                  {" "}
                  <i className="bi bi-cancel"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="row">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
